import models from "modules/models";
import BaseRxApiService from "./baseRxApiService";

export default class PropertyRxApiService extends BaseRxApiService {
  constructor() {
    super(models.PROPERTY);
  }
}
